import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from '../../../../../shared/primary-image-modal';
import FeaturedWireContext from '../context';

const Container = styled.a`
  border-radius: 3px;
  box-shadow: 0px 2px 4px rgba(50, 50, 71, 0.06), 0px 1px 4px rgba(50, 50, 71, 0.06);
  border: 1px solid ${props => props.theme.errorColor};
  background-color: #f8f9fc;
  ${props => (props.theme.isMobile ? `
    width: 100%;
    height: 168px;
  ` : `
    width: 120px;
    height: 68px;
  `)};
  display: flex;
  flex-direction: column;
  align-items: center;

  & > strong, & > em {
    font-weight: 800;
    font-size: ${props => (props.theme.isMobile ? '14px' : '8px')};
    line-height: 120%;
    text-align: center;
    text-transform: uppercase;
    font-style: normal;
  }

  & > strong {
    margin-top: ${props => (props.theme.isMobile ? '20px' : '6px')};
    color: #19202d;
    :hover {
      color: #19202d;
    }
  }

  & > em {
    margin-top: ${props => (props.theme.isMobile ? '10px' : '0')};
  }

  &:hover {
    text-decoration: unset !important;
    > strong {
      text-decoration: none;
    }
    > em {
      text-decoration: underline;
    }
  }

  & > .fa-picture-o {
    font-size: ${props => (props.theme.isMobile ? '48px' : '20px')};
    margin-top: ${props => (props.theme.isMobile ? '40px' : '15px')};
    color: #bbcbd8;
    :hover {
      color: #bbcbd8;
    }
  }
`;

export default function DummyImage({ wireId, slug }) {
  const { dispatch } = React.useContext(FeaturedWireContext);
  const [showModal, setShowModal] = React.useState(false);

  const onClick = e => {
    e && e.preventDefault();
    setShowModal(true);
  };

  const modalProps = {
    wireId,
    showModal,
    onAssigned: primaryImageUrl => {
      const payload = { slug, primaryImageUrl, removable: true };
      dispatch({ type: 'updateWire', payload });
    },
    onClose: () => setShowModal(false),
  };

  return (
    <>
      <Container href="#" onClick={onClick}>
        <span className="fa fa-picture-o" />
        <strong>primary image required</strong>
        <em>assign primary image</em>
      </Container>
      <Modal {...modalProps} />
    </>
  );
}

DummyImage.propTypes = {
  wireId: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
};
